import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mfa',{attrs:{"submit-button-condition":false,"on-ready":_vm.onReady},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticStyle:{"text-align":"center"}},[(_vm.error)?_c(VAlert,{attrs:{"type":"error","dismissible":""}},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c(VIcon,{attrs:{"color":"#808080","size":"90"}},[_vm._v("usb")])],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }